import React from 'react';
import { Link } from 'react-router-dom';

import { Container, Row } from 'react-bootstrap';
import { Search, XCircle } from 'react-feather';
import Sidebar from '../navbar/Sidebar';

import logo from '../../assets/images/logo.png';
import menu from '../../assets/images/icons/menu.svg';

export default function MobileMenu() {
    return (
        <>
            <div>
                <img
                    src={menu}
                    alt='منو'
                    type='button'
                    data-bs-toggle='offcanvas'
                    data-bs-target='#offcanvasMenu'
                    aria-controls='offcanvasMenu'
                />

                <Container>
                    <Row>
                        <div
                            className='offcanvas offcanvas-end'
                            tabIndex='-1'
                            id='offcanvasMenu'
                            aria-labelledby='offcanvasMenuLabel'
                        >
                            <XCircle
                                data-bs-dismiss='offcanvas'
                                aria-label='Close'
                                className='closing'
                            />

                            <div className='space-30' />

                            <div className='offcanvas-header'>
                                <Link to='/'>
                                    <img
                                        src={logo}
                                        alt='داشبورد شاپینکس'
                                        title='داشبورد شاپینکس'
                                        className='logo'
                                    />
                                </Link>
                            </div>

                            <div className='nav-center'>
                                <div className='search'>
                                    <form>
                                        <input placeholder='جستجو...' />

                                        <span className='search-icon'>
                                            <Search />
                                        </span>
                                    </form>
                                </div>
                            </div>

                            <div className='offcanvas-body'>
                                <Sidebar />
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </>
    );
}
